import React, { useEffect, useRef, useState } from 'react'
import Container from '../../components/Container';
import { Link, useLocation, useNavigate } from 'react-router-dom'
import DatePicker from "react-datepicker";
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import DataFetching from "../../helper/DataFetching";
import renderDataTable from "../../helper/renderDataTable";
import { ApiHandler } from "../../helper/ApiHandler";
import Loading from "../../components/Loading";
import { ButtonBlock, ButtonDelete, SearchClear, formatMoment, onBlurDate, onFocusDate, submitDATE, tableDATE } from '../../helper/CommonFunction';
import { ModalLarge, ModalSmall } from '../../components/ModalComponets';
import AddDomainUsers from './AddDomainUsers';
import Breadcrumb from '../../components/Breadcrumb';
import { MdDomainAdd, MdEmail } from 'react-icons/md';
import ActionDetailModal from '../../components/ActionDetailModal'

const Users = () => {
    const location = useLocation();
    const token = useSelector((state) => state.user.userToken)

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [activeTab, setActiveTab] = useState(0);
    const [actionUserId, setActionUserId] = useState(null);

    const [filteredData, setFilteredData] = useState([]);
    const [pending, setPending] = useState(true);
    const [resetSearch, setResetSearch] = useState(true);
    const [pageOpen, setPageOpen] = useState(false);

    const [form_date, setForm_date] = useState(null);
    const [end_date, setEnd_date] = useState(null);
    const [form_date1, setForm_date1] = useState('');
    const [end_date1, setEnd_date1] = useState('');

    const [currentPage, setCurrentPage] = useState(1);
    const [pageLimit, setPageLimit] = useState(10);
    const [totalPages, setTotalPages] = useState(0);
    const [hide, setHide] = useState('');
    const [from, setFrom] = useState(false);

    const [deleteId, setdeleteId] = useState(null);
    const [deleteModal, setDeleteModal] = useState(false);

    const [showDomainModal, setShowDomainModal] = useState(false);
    const [actionModalOpen, setActionModalOpen] = useState(false);

    const [selectedUserForDomain, setSelectedUserForDomain] = useState(null);

    const [user, setUser] = useState({
        userId: '',
        userName: '',
        email: '',
        cell: '',
    });

    // NEW — SEND MAIL STATES
    const [sendEmailModal, setSendEmailModal] = useState(false);
    const [sendEmailValue, setSendEmailValue] = useState('');
    const [sendEmailUser, setSendEmailUser] = useState(null);
    const [sendingEmail, setSendingEmail] = useState(false);

    // NEW — send date states for modal
    const [sendDate, setSendDate] = useState(null);           // Date object
    const [sendDateStr, setSendDateStr] = useState('');       // formatted yyyy-MM-dd for API
    const datePickerRef = useRef(null);                       // ref to open DatePicker when modal opens

    const { userId, email, userName, cell } = user;

    const onInputChange = (e) => {
        setUser({ ...user, [e.target.name]: e.target.value });
    };

    const fetchData = async (tabId = activeTab) => {
        setPending(true);

        let type;
        switch (tabId) {
            case 0: type = "unblock"; break;
            case 1: type = "block"; break;
            case 2: type = ""; break;
            default: type = "unblock";
        }

        const body = {
            page: currentPage - 1,
            perpage: pageLimit,
            type: type,
            user_id: userId,
            name: userName,
            email: email,
            cell: cell,
            fromDate: form_date1,
            toDate: end_date1,
        };

        DataFetching(
            setPending,
            '/user_list.php',
            'POST',
            token,
            dispatch,
            navigate,
            setFilteredData,
            setTotalPages,
            body,
            setResetSearch,
            resetSearch
        );
    };

    const handleTabClick = (tabId) => {
        setCurrentPage(1);
        setActiveTab(tabId);
        fetchData(tabId);
    };

    const handleSearchClick = () => {
        if (form_date && !end_date) return setHide("This field is required");
        if (hide || from) return;

        setCurrentPage(1);
        setResetSearch(prev => !prev);
    };

    const handleClearSearch = () => {
        setHide('');
        setFrom(false);

        setUser({
            userId: '',
            userName: '',
            email: '',
            cell: '',
        });

        setForm_date(null);
        setForm_date1("");
        setEnd_date(null);
        setEnd_date1("");

        setCurrentPage(1);
        setPageLimit(10);
        setActiveTab(0);

        setResetSearch(prev => !prev);
    };

    useEffect(() => {
        if (!resetSearch) return;
        fetchData();
    }, [currentPage, pageLimit, location, resetSearch]);

    const DeleteUserModal = (row) => {
        setdeleteId(row);
        setDeleteModal(true);
    };

    const handleAddDomainClick = (row) => {
        setSelectedUserForDomain(row);
        setShowDomainModal(true);
    };

    // OPEN SEND EMAIL MODAL
    const handleOpenSendEmail = (row) => {
        setSendEmailUser(row);
        setSendEmailValue(row.email || '');
        setSendDate(null);
        setSendDateStr('');
        setSendEmailModal(true);
    };

    // When modal opens, open the DatePicker input programmatically
    useEffect(() => {
        if (sendEmailModal && datePickerRef.current && typeof datePickerRef.current.setOpen === 'function') {
            // small timeout ensures component mounts before we call setOpen
            setTimeout(() => {
                try {
                    datePickerRef.current.setOpen(true);
                } catch (e) {
                    // ignore if setOpen not available
                }
            }, 120);
        }
    }, [sendEmailModal]);

    // EMAIL VALIDATION
    const validateEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);

    // helper to format date to yyyy-MM-dd for API
    const formatDateForApi = (d) => {
        if (!d) return '';
        const yyyy = d.getFullYear();
        const mm = String(d.getMonth() + 1).padStart(2, '0');
        const dd = String(d.getDate()).padStart(2, '0');
        return `${yyyy}-${mm}-${dd}`;
    };

    // SEND EMAIL API CALL (includes send_date now)
    const submitSendEmail = async () => {
        if (!sendEmailUser) return;

        if (!sendEmailValue || !validateEmail(sendEmailValue)) {
            toast.error("Please enter a valid email");
            return;
        }

        if (!sendDate) {
            toast.error("Please select a send date");
            return;
        }

        setSendingEmail(true);

        const body = {
            user_id: String(sendEmailUser.id),
            email: sendEmailValue,
            send_date: sendDateStr || formatDateForApi(sendDate), // ensure formatted date is provided
        };

        try {
            const response = await fetch(
                'https://api.myad360.com/mail/send_revenue_mail.php',
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "token": token
                    },
                    body: JSON.stringify(body)
                }
            );

            const result = await response.json();

            // SUCCESS CASE
            if (result?.status === 1 || result?.status === "1") {
                toast.success(result?.msg || "Mail Sent Successfully");

                // Close modal and reset
                setSendEmailModal(false);
                setSendEmailUser(null);
                setSendEmailValue('');
                setSendDate(null);
                setSendDateStr('');
            }

            // FAILED CASE (status 0)
            else if (result?.status === 0 || result?.status === "0") {
                toast.error(result?.msg || "Failed to send mail");
            }

            // Unexpected result
            else {
                toast.error("Unexpected response from server");
            }

        } catch (err) {
            toast.error("Network error: Could not send mail");
        }

        setSendingEmail(false);
    };

    // ACTION COLUMNS
    const column = [
        { name: 'User ID', selector: row => row.id, width: '7%' },
        { name: 'Full Name', selector: row => row.full_name },
        { name: 'Email', selector: row => row.email },
        {
            name: "App Url",
            selector: (row) => (
                <Link
                    to={row.domain}
                    target="_blank"
                    className="underline text-orange-500 hover:text-orange-600"
                >
                    {row.domain}
                </Link>
            )
        },
        { name: 'Cell', selector: row => row.cell, width: '14%' },
        {
            name: "Register Date",
            selector: row => <span>{formatMoment(row.created_date)}</span>,
            width: '14%'
        },

        // UPDATED ACTION BUTTONS
        {
            name: "Actions",
            cell: (row) => (
                <div>

                    <button
    className='rounded-[4px] mr-1 mb-1 bg-orange-500 hover:bg-orange-600 text-white text-[13px] transition-colors duration-200'
    style={{ padding: '5px 6px' }}
    onClick={() => handleAddDomainClick(row)}
>
                        <MdDomainAdd size={14} />
                    </button>

                    {/* SHOW MAIL ICON FIX — WORKS FOR 1 OR "1" */}
                    {String(row.is_send_revenue_mail_button) === "1" && (
                        <button
    className='rounded-[4px] mr-1 mb-1 bg-amber-500 hover:bg-amber-600 text-white text-[13px] transition-colors duration-200'
    style={{ padding: '5px 6px' }}
    title='Send Revenue Mail'
    onClick={() => handleOpenSendEmail(row)}
>
                            <MdEmail size={14} />
                        </button>
                    )}

                    <ButtonDelete onclick={() => DeleteUserModal(row)} />

                    {row.is_block === "0"
                        ? <ButtonBlock onclick={() => HandleBlockUnBlock(row)} />
                        : <ButtonBlock onclick={() => HandleBlockUnBlock(row)} block={false} />
                    }
                    <svg
                        onClick={() => {
                            setActionUserId(row.id);   // ✅ SEND USER ID
                            setActionModalOpen(true);
                        }}
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        className="w-6 h-6 cursor-pointer text-orange-500 hover:text-orange-600"
                    >
                        <circle cx="12" cy="12" r="10" />
                        <line x1="12" y1="8" x2="12" y2="12" />
                        <circle cx="12" cy="16" r="1" />
                    </svg>

                </div>
            ),
            width: '12%'
        }
    ];

    const DeleteUser = async () => {
        const body = { user_id: deleteId.id }

        try {
            const result = await ApiHandler('/user_delete.php', 'POST', body, token, dispatch, navigate);

            if (result?.data?.status === "1") {
                toast.success(result?.data?.msg)
                setDeleteModal(false)
                setdeleteId(null)
                setResetSearch(prev => !prev)
            } else {
                toast.error(result?.data?.msg)
            }
        } catch {
            setDeleteModal(false)
        }
    };

    const [blockUnBlockId, setBlockUnBlockId] = useState(null);
    const [blockUnBlockModal, setBlockUnBlockModal] = useState(false);

    const HandleBlockUnBlock = (row) => {
        setBlockUnBlockId(row);
        setBlockUnBlockModal(true);
    };

    const BlockUser = async () => {
        const body = {
            user_id: blockUnBlockId.id,
            is_block: blockUnBlockId.is_block === '1' ? "0" : "1",
        };

        try {
            const result = await ApiHandler('/user_block_unblock.php', 'POST', body, token, dispatch, navigate);

            if (result?.data?.status === "1") {
                toast.success(result?.data?.msg)
                setBlockUnBlockModal(false)
                setBlockUnBlockId(null)
                setResetSearch(prev => !prev)
            } else {
                toast.error(result?.data?.msg)
            }
        } catch {
            setBlockUnBlockModal(false)
            setBlockUnBlockId(null)
        }
    };

    if (pageOpen) return <Loading />;

        return (
        <>
            <Breadcrumb pageName="Users" />

            <Container>
                <div className="border border-orange-100 rounded-xl shadow-[0_2px_16px_rgba(0,0,0,0.04)] w-full bg-white overflow-hidden">
                    <ul className="nav nav-tabs border-b border-orange-100 px-4 pt-3">
                        {['Un-Block', 'Block', 'All'].map((tab, index) => (
                            <li
                                key={index}
                                className={activeTab === index ? "active" : ""}
                            >
                                <Link onClick={() => handleTabClick(index)}>
                                    {tab}
                                </Link>
                            </li>
                        ))}
                    </ul>

                    <div className="p-3">
                        <div className="bg-white px-3 py-3 rounded-lg table-custom-filters">

                            <p className="text-lg font-medium py-[1%] text-gray-900">Filters:</p>

                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-2">

                                <div>
                                    <label>By User ID</label>
                                    <input
                                        type="text"
                                        name="userId"
                                        className="form-control"
                                        value={userId}
                                        onChange={onInputChange}
                                        placeholder="User ID"
                                    />
                                </div>

                                <div>
                                    <label>By Name</label>
                                    <input
                                        type="text"
                                        name="userName"
                                        className="form-control"
                                        value={userName}
                                        onChange={onInputChange}
                                        placeholder="Name"
                                    />
                                </div>

                                <div>
                                    <label>By Email</label>
                                    <input
                                        type="email"
                                        name="email"
                                        className="form-control"
                                        value={email}
                                        onChange={onInputChange}
                                        placeholder="Email"
                                    />
                                </div>

                                <div>
                                    <label>By Cell</label>
                                    <input
                                        type="text"
                                        name="cell"
                                        className="form-control"
                                        value={cell}
                                        onChange={onInputChange}
                                        placeholder="Cell"
                                    />
                                </div>

                                <div>
                                    <label>From Date</label>
                                    <DatePicker
                                        selected={form_date}
                                        onChange={(date) =>
                                            tableDATE(date, setForm_date, setForm_date1, end_date, setFrom)
                                        }
                                        dateFormat="yyyy-MM-dd"
                                        className="form-control"
                                    />
                                </div>

                                <div>
                                    <label>To Date</label>
                                    <DatePicker
                                        selected={end_date}
                                        onChange={(date) =>
                                            submitDATE(date, setHide, setEnd_date, setEnd_date1, setFrom, form_date)
                                        }
                                        dateFormat="yyyy-MM-dd"
                                        className="form-control"
                                        minDate={form_date}
                                    />
                                    {hide && (
                                        <div className="text-red-500 font-medium">{hide}</div>
                                    )}
                                </div>
                            </div>

                            <SearchClear search={handleSearchClick} clear={handleClearSearch} />
                        </div>

                        <div className="py-3">
                            {['un-block', 'block', 'all'].map((tabName, index) => (
                                <div
                                    key={index}
                                    className={`car_cluth car_engine ${activeTab === index ? "active" : "hide"
                                        }`}
                                >
                                    {renderDataTable(
                                        filteredData,
                                        column,
                                        pending,
                                        currentPage,
                                        setPageLimit,
                                        setCurrentPage,
                                        totalPages,
                                        pageLimit,
                                        setResetSearch,
                                        dispatch,
                                        navigate
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </Container>

            {blockUnBlockModal && blockUnBlockId && (
                <ModalSmall
                    isOpen={true}
                    onClose={() => setBlockUnBlockModal(false)}
                    onConfirm={BlockUser}
                >
                    <h2 className="text-lg font-bold mb-1 text-gray-900">Confirm!</h2>
                    <p>Are you sure you want to change block status?</p>
                </ModalSmall>
            )}

            {deleteModal && deleteId && (
                <ModalSmall
                    isOpen={true}
                    onClose={() => setDeleteModal(false)}
                    onConfirm={DeleteUser}
                >
                    <h2 className="text-lg font-bold mb-1 text-gray-900">Confirm!</h2>
                    <p>Are you sure you want to delete this user?</p>
                </ModalSmall>
            )}

            {showDomainModal && selectedUserForDomain && (
                <AddDomainUsers
                    isOpen={true}
                    onClose={() => setShowDomainModal(false)}
                    showData={selectedUserForDomain}
                    setResetSearch={setResetSearch}
                />
            )}

            {/* SEND EMAIL MODAL */}
            {sendEmailModal && sendEmailUser && (
                <ModalLarge
                    isOpen={true}
                    onClose={() => {
                        setSendEmailModal(false);
                        setSendEmailUser(null);
                        setSendEmailValue('');
                        setSendDate(null);
                        setSendDateStr('');
                    }}
                    onConfirm={null}     // Disable default confirm
                    hideFooter={true}    // Hide default footer
                >
                    <div className="relative p-6 sm:p-8 md:p-10">

                        {/* Header Title */}
                        <h2 className="text-2xl font-bold text-gray-900 mb-6">
                            Send Revenue Mail
                        </h2>

                        {/* Email Input Field */}
                        <div className="mb-6">
                            <label className="text-sm font-semibold text-gray-800 mb-2 block">
                                Email Address
                            </label>
                            <input
                                type="email"
                                className="w-full px-4 py-3 border border-orange-100 rounded-lg 
           focus:ring-2 focus:ring-orange-400 focus:border-orange-300
           outline-none shadow-sm transition-all duration-200"
                                value={sendEmailValue}
                                onChange={(e) => setSendEmailValue(e.target.value)}
                                placeholder="Enter email address"
                            />
                        </div>

                        {/* Date Picker Field */}
                        <div className="mb-8">
                            <label className="text-sm font-medium text-gray-700 mb-2 block">
                                Select Send Date
                            </label>

                            <DatePicker
                                ref={datePickerRef}                 // used to programmatically open
                                selected={sendDate}
                                onChange={(date) => {
                                    setSendDate(date);
                                    const formatted = formatDateForApi(date);
                                    setSendDateStr(formatted);
                                }}
                                dateFormat="yyyy-MM-dd"
                                className="form-control w-full px-4 py-3 border border-orange-100 rounded-lg focus:ring-2 focus:ring-orange-400 focus:border-orange-300 outline-none transition-all duration-200"
                                placeholderText="Select date (yyyy-mm-dd)"
                            />
                        </div>

                        {/* Submit Button */}
                        <button
                            type="button"
                            className="w-full py-3 bg-orange-500 hover:bg-orange-600
       rounded-lg font-semibold text-white text-lg
       transition-all duration-200 shadow-md shadow-orange-200 hover:shadow-lg
       disabled:opacity-50 disabled:cursor-not-allowed"
                            onClick={submitSendEmail}
                            disabled={sendingEmail || !sendEmailValue || !sendDate}
                        >
                            {sendingEmail ? (
                                <span className="flex items-center justify-center gap-2">
                                    <svg
                                        className="animate-spin h-5 w-5 text-gray-900"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                    >
                                        <circle
                                            className="opacity-25"
                                            cx="12"
                                            cy="12"
                                            r="10"
                                            stroke="currentColor"
                                            strokeWidth="4"
                                        ></circle>
                                        <path
                                            className="opacity-75"
                                            fill="currentColor"
                                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 
                               5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 
                               5.824 3 7.938l3-2.647z"
                                        ></path>
                                    </svg>
                                    Sending...
                                </span>
                            ) : (
                                "Send Email"
                            )}
                        </button>
                    </div>
                </ModalLarge>


            )}
            {actionModalOpen && (
                <ActionDetailModal
                    open={actionModalOpen}
                    onClose={() => {
                        setActionModalOpen(false);
                        setActionUserId(null);
                    }}
                    userId={actionUserId}   // ✅ DYNAMIC USER ID
                />
            )}

        </>
    );
};

export default Users;
